const questionsMockTemplates = {
    visible_enough_question: {
        id: "visible_enough_question",
        title: {
            value: "Im I visible enough",
        },
        knowledgeBaseName: "questions",
        dependencies: ["git"],
        rows: [
            {
                items: [
                    {
                        id: "collaboration.collaboration.channels",
                        query: {
                            id: "collaboration.collaboration.channels",
                            assignToProperty: "channels",
                        },
                        title: {
                            value: "Most used channels",
                        },
                        tooltip: {
                            dependencies: "slack",
                            text: "Shows which Slack channels you use most. Shows if you're communicating too much/too little in certain Slack channels",
                        },
                        knowledgeBaseName: "most-used-channels",
                        skeleton: {
                            streaming: true,
                            property: "channels",
                        },
                        type: "pie-chart",
                        chart: {
                            type: "pie",
                            property: "channels",
                            nameKey: "name",
                            dataKey: "interactionCount",
                            sortKey: "interactionCount",
                            tooltipKeys: [
                                {
                                    property: "interactionCount",
                                    name: "Interactions Count",
                                },
                                {
                                    property: "baseline",
                                    name: "Average Interactions Count",
                                },
                            ],
                        },
                        sizing: {
                            xs: 12,
                            md: 4,
                        },
                    },
                    {
                        id: "collaboration.collaboration.meetingCollaborators",
                        query: {
                            id: "collaboration.collaboration.meetingCollaborators",
                            assignToProperty: "meetingCollaborators",
                        },
                        title: {
                            value: "Most frequent collaborators",
                        },
                        tooltip: {
                            dependencies: "meetings",
                            text: "Who is working with whom most often.",
                        },
                        skeleton: {
                            streaming: true,
                            property: "meetingCollaborators",
                        },
                        knowledgeBaseName: "frequent-collaborators",
                        list: {
                            type: "text",
                            property: "meetingCollaborators",
                            columns: [
                                {
                                    property: "email",
                                    type: "avatar",
                                },
                                {
                                    type: "composite",
                                    parts: [
                                        {
                                            property: "email",
                                            type: "string",
                                        },
                                        {
                                            property: "duration",
                                            type: "stage-duration",
                                            name: "Time in meetings",
                                        },
                                        {
                                            property: "meetings",
                                            type: "number",
                                            name: "Number of meetings",
                                        },
                                        {
                                            property: "duration",
                                            type: "progress",
                                        },
                                    ],
                                },
                            ],
                        },
                        sizing: {
                            xs: 12,
                            md: 4,
                        },
                    },
                    {
                        id: "collaboration.collaboration.meetingFrequency",
                        query: {
                            id: "collaboration.collaboration.meetingFrequency",
                            assignToProperty: "meetingFrequency",
                        },
                        title: {
                            value: "Hours in meetings",
                        },
                        tooltip: {
                            dependencies: "meetings",
                            text: "Uncover which meetings are blocking the most time in your calendar",
                        },
                        knowledgeBaseName: "hours-in-meetings",
                        skeleton: {
                            streaming: true,
                            property: "meetingFrequency",
                        },
                        type: "pie-chart",
                        chart: {
                            type: "pie",
                            property: "meetingFrequency",
                            nameKey: "name",
                            dataKey: "duration",
                            sortKey: "duration",
                            tooltipKeys: [
                                {
                                    property: "duration",
                                    name: "Time in meeting",
                                    type: "duration",
                                },
                                {
                                    property: "baseline",
                                    name: "Average time in meeting",
                                    type: "duration",
                                },
                            ],
                        },
                        sizing: {
                            xs: 12,
                            md: 4,
                        },
                    },
                ],
            },
        ],
    },
    sustainable_work_question: {
        id: "sustainable_work_question",
        title: {
            value: "Am I working sustainably?",
        },
        knowledgeBaseName: "questions",
        dependencies: ["git"],
        rows: [
            {
                items: [
                    {
                        id: "pm.tickets.ticketsAssigned",
                        query: {
                            id: "pm.tickets.ticketsAssigned",
                            assignToProperty: "ticketsAssigned",
                            variables: {
                                "creator-assignee": "both",
                            },
                        },
                        title: {
                            value: "Tickets assigned",
                        },
                        tooltip: {
                            dependencies: "pm",
                            text: "Keeping track of the number of issues that are assigned to you each day of the week can provide valuable insights into the workload distribution of your project and help you identify potential areas for improvement",
                        },
                        skeleton: {
                            streaming: true,
                            property: "ticketsAssigned",
                        },
                        type: "line-chart",
                        chart: {
                            type: "line",
                            property: "ticketsAssigned",
                            expandable: false,
                            xValues: [
                                {
                                    dataKey: "day",
                                    type: "weekday",
                                },
                            ],
                            yValues: [
                                {
                                    type: "monotone",
                                    dataKey: "max.issues",
                                    name: "Most issues",
                                    stroke: "#82ca9d",
                                    style: {
                                        opacity: "0",
                                    },
                                    unit: "number",
                                },
                                {
                                    type: "monotone",
                                    dataKey: "min.issues",
                                    name: "Least issues",
                                    stroke: "#8884d8",
                                    style: {
                                        opacity: "0",
                                    },
                                    unit: "number",
                                },
                            ],
                            customized: ["rectangle"],
                        },
                        sizing: {
                            md: 4,
                            xs: 12,
                        },
                    },
                    {
                        id: "collaboration.collaboration.commsPerDayHour",
                        query: {
                            id: "collaboration.collaboration.commsPerDayHour",
                            assignToProperty: "commsPerDayHour",
                        },
                        title: {
                            value: "Time of communication",
                        },
                        tooltip: {
                            dependencies: "collaboration",
                            text: "What time and day you are communicating. The more green the square, the more you communicate in that slot. Increases understanding of when you have time for deep work",
                        },
                        knowledgeBaseName: "time-of-communications",
                        skeleton: {
                            streaming: true,
                            property: "commsPerDayHour",
                        },
                        type: "heatmap-chart",
                        chart: {
                            type: "heatmap",
                            property: "commsPerDayHour",
                            options: {
                                inverse: false,
                                type: "time",
                            },
                            yValues: [
                                {
                                    dataKey: "reactions",
                                    name: "Reactions",
                                    type: "number",
                                    multiplier: 1,
                                    aggregationMethod: "sum",
                                },
                                {
                                    dataKey: "messages",
                                    name: "Messages",
                                    type: "number",
                                    multiplier: 1,
                                    aggregationMethod: "sum",
                                },
                                {
                                    dataKey: "huddles",
                                    name: "Huddles",
                                    type: "number",
                                    multiplier: 1,
                                    aggregationMethod: "sum",
                                },
                                {
                                    dataKey: "meetings",
                                    name: "Meetings",
                                    type: "number",
                                    multiplier: 1,
                                    aggregationMethod: "sum",
                                },
                            ],
                            xValues: [
                                {
                                    dataKey: "datetime",
                                    type: "datetime",
                                },
                            ],
                            cellStyle: {
                                background: {
                                    r: 12,
                                    g: 160,
                                    b: 44,
                                },
                                fontSize: "0",
                                border: {
                                    color: "#3d3d3d",
                                    width: "1px",
                                    style: "solid",
                                    radius: "4px",
                                    height: "23px",
                                },
                            },
                        },
                        sizing: {
                            xs: 12,
                            md: 8,
                        },
                    },
                ],
            },
            {
                items: [
                    {
                        id: "wellbeing.wellbeing.longHours",
                        query: {
                            id: "wellbeing.wellbeing.longOutHours",
                            extractFromProperty: "longHours",
                            assignToProperty: "longHours",
                        },
                        title: {
                            value: "Long Hours",
                        },
                        tooltip: {
                            dependencies: "wellbeing",
                            text: "Working Hours Surpassed. Working long hours consistently has a negative impact on wellbeing",
                        },
                        knowledgeBaseName: "long-hours",
                        skeleton: {
                            streaming: true,
                            property: "longHours",
                        },
                        type: "bar-chart",
                        chart: {
                            type: "bar",
                            property: "longHours",
                            yValues: [
                                {
                                    dataKey: "value",
                                    name: "Long hours",
                                    fill: "#8884d8",
                                    type: "duration",
                                },
                                {
                                    dataKey: "baseline",
                                    name: "Average ",
                                    fill: "#82ca9d",
                                    maxBarSize: 10,
                                    barSize: 1,
                                    type: "duration",
                                },
                            ],
                            xValues: [
                                {
                                    dataKey: "datetime",
                                    type: "datetime",
                                },
                            ],
                        },
                        sizing: {
                            xs: 12,
                            md: 4,
                        },
                    },
                    {
                        id: "wellbeing.wellbeing.focusTime",
                        query: {
                            id: "wellbeing.wellbeing.focusTime",
                            assignToProperty: "focusTime",
                        },
                        title: {
                            value: "Focus time",
                        },
                        tooltip: {
                            dependencies: "collaboration",
                            text: "Time available for deep solo work. How many hours are available to you for productive and deep focus work",
                        },
                        knowledgeBaseName: "focus-time",
                        skeleton: {
                            streaming: true,
                            property: "focusTime",
                        },
                        type: "heatmap-chart",
                        chart: {
                            type: "heatmap",
                            property: "focusTime",
                            options: {
                                inverse: true,
                                type: "time",
                            },
                            yValues: [
                                {
                                    dataKey: "reactions",
                                    name: "Reactions",
                                    type: "duration",
                                    multiplier: 1,
                                    aggregationMethod: "avg",
                                },
                                {
                                    dataKey: "messages",
                                    name: "Messages",
                                    type: "duration",
                                    multiplier: 1,
                                    aggregationMethod: "avg",
                                },
                                {
                                    dataKey: "huddles",
                                    name: "Huddles",
                                    type: "duration",
                                    multiplier: 1,
                                    aggregationMethod: "avg",
                                },
                                {
                                    dataKey: "meetings",
                                    name: "Meetings",
                                    type: "duration",
                                    multiplier: 1,
                                    aggregationMethod: "avg",
                                },
                                {
                                    dataKey: "focus",
                                    name: "Focus",
                                    type: "number",
                                    multiplier: 1,
                                    aggregationMethod: "avg",
                                    border: {
                                        color: "#60D297",
                                        width: "1px",
                                        style: "dashed",
                                        radius: "4px",
                                        height: "23px",
                                    },
                                },
                            ],
                            xValues: [
                                {
                                    dataKey: "datetime",
                                    type: "datetime",
                                },
                            ],
                            cellStyle: {
                                background: {
                                    r: 136,
                                    g: 132,
                                    b: 216,
                                },
                                opacity: 1,
                                fontSize: "0",
                                border: {
                                    color: "#474747",
                                    width: "1px",
                                    style: "solid",
                                    radius: "4px",
                                    height: "23px",
                                },
                            },
                        },
                        sizing: {
                            xs: 12,
                            md: 8,
                        },
                    },
                ],
            },
            {
                items: [
                    {
                        id: "wellbeing.wellbeing.upskilling",
                        query: {
                            id: "wellbeing.wellbeing.upskilling",
                            assignToProperty: "upskilling",
                        },
                        title: {
                            value: "Upskilling",
                        },
                        tooltip: {
                            dependencies: "git",
                            text: "Time spent upskilling. Shows time spent using languages that are not your 'main' languages",
                        },
                        skeleton: {
                            streaming: true,
                            property: "upskilling",
                        },
                        knowledgeBaseName: "upskilling",
                        specialComponent: "upskilling",
                        sizing: {
                            xs: 12,
                            md: 12,
                            minHeight: "180px",
                        },
                    },
                ],
            },
        ],
    },
    focus_time_question: {
        id: "focus_time_question",
        title: {
            value: "Do I have enough focus time to produce high quality work?",
        },
        knowledgeBaseName: "questions",
        dependencies: ["git"],
        rows: [
            {
                items: [
                    {
                        id: "git.commits.codeSegmentation",
                        query: {
                            id: "git.commits.commitsPerDay",
                            extractFromProperty: "codeSegmentation",
                            assignToProperty: "codeSegmentation",
                        },
                        title: {
                            value: "Code segmentation",
                        },
                        tooltip: {
                            dependencies: "git",
                            text: "How many lines you are changing by date. Showcases total code written/removed in a given day, which could serve as a measure of productivity.",
                        },
                        skeleton: {
                            streaming: true,
                            property: "codeSegmentation",
                        },
                        type: "bar-chart",
                        chart: {
                            type: "bar",
                            property: "codeSegmentation",
                            yValues: [
                                {
                                    dataKey: "additions",
                                    name: "Code added",
                                    stackId: "a",
                                    fill: "#6C63F0",
                                    type: "number",
                                },
                                {
                                    propertyPath: "baseline.additions",
                                    dataKey: "baselineAdditions",
                                    name: "Average ",
                                    stackId: "b",
                                    maxBarSize: 10,
                                    barSize: 1,
                                    fill: "#9993F6",
                                    type: "dow",
                                },
                                {
                                    dataKey: "deletions",
                                    name: "Code deleted",
                                    stackId: "a",
                                    fill: "#3AACFF",
                                    type: "number",
                                },
                                {
                                    propertyPath: "baseline.deletions",
                                    dataKey: "baselineDeletions",
                                    name: "Average ",
                                    stackId: "b",
                                    maxBarSize: 10,
                                    barSize: 1,
                                    fill: "#8ECEFC",
                                    type: "dow",
                                },
                                {
                                    dataKey: "modifications",
                                    name: "Code modified",
                                    stackId: "a",
                                    fill: "#ED589D",
                                    type: "number",
                                },
                                {
                                    propertyPath: "baseline.modifications",
                                    dataKey: "baselineModifications",
                                    name: "Average ",
                                    stackId: "b",
                                    maxBarSize: 10,
                                    barSize: 1,
                                    fill: "#F4A7CB",
                                    type: "dow",
                                },
                            ],
                            xValues: [
                                {
                                    dataKey: "datetime",
                                    type: "datetime",
                                },
                            ],
                            tooltipValues: [
                                {
                                    name: "Total changes",
                                    dataKey: "total",
                                    type: "number",
                                },
                                {
                                    name: "Average total changes",
                                    propertyPath: "baseline.total",
                                    dataKey: "baselineTotal",
                                    type: "dow",
                                },
                            ],
                        },
                        sizing: {
                            xs: 12,
                            md: 4,
                        },
                    },
                    {
                        id: "wellbeing.wellbeing.focusTime",
                        query: {
                            id: "wellbeing.wellbeing.focusTime",
                            assignToProperty: "focusTime",
                        },
                        title: {
                            value: "Focus time",
                        },
                        tooltip: {
                            dependencies: "collaboration",
                            text: "Time available for deep solo work. How many hours are available to you for productive and deep focus work",
                        },
                        knowledgeBaseName: "focus-time",
                        skeleton: {
                            streaming: true,
                            property: "focusTime",
                        },
                        type: "heatmap-chart",
                        chart: {
                            type: "heatmap",
                            property: "focusTime",
                            options: {
                                inverse: true,
                                type: "time",
                            },
                            yValues: [
                                {
                                    dataKey: "reactions",
                                    name: "Reactions",
                                    type: "duration",
                                    multiplier: 1,
                                    aggregationMethod: "avg",
                                },
                                {
                                    dataKey: "messages",
                                    name: "Messages",
                                    type: "duration",
                                    multiplier: 1,
                                    aggregationMethod: "avg",
                                },
                                {
                                    dataKey: "huddles",
                                    name: "Huddles",
                                    type: "duration",
                                    multiplier: 1,
                                    aggregationMethod: "avg",
                                },
                                {
                                    dataKey: "meetings",
                                    name: "Meetings",
                                    type: "duration",
                                    multiplier: 1,
                                    aggregationMethod: "avg",
                                },
                                {
                                    dataKey: "focus",
                                    name: "Focus",
                                    type: "number",
                                    multiplier: 1,
                                    aggregationMethod: "avg",
                                    border: {
                                        color: "#60D297",
                                        width: "1px",
                                        style: "dashed",
                                        radius: "4px",
                                        height: "23px",
                                    },
                                },
                            ],
                            xValues: [
                                {
                                    dataKey: "datetime",
                                    type: "datetime",
                                },
                            ],
                            cellStyle: {
                                background: {
                                    r: 136,
                                    g: 132,
                                    b: 216,
                                },
                                opacity: 1,
                                fontSize: "0",
                                border: {
                                    color: "#474747",
                                    width: "1px",
                                    style: "solid",
                                    radius: "4px",
                                    height: "23px",
                                },
                            },
                        },
                        sizing: {
                            xs: 12,
                            md: 8,
                        },
                    },
                ],
            },
            {
                singleCard: true,
                items: [
                    {
                        id: "git.mrs.stats.approvalRateOnMyMrs",
                        query: {
                            id: "git.mrs.stats",
                            assignToProperty: "stats",
                        },
                        title: {
                            value: "Approval rate on my MRs",
                        },
                        tooltip: {
                            dependencies: "git",
                            text: "Percentage of your MRs have been approved before getting merged this week compared to your average. If your MRs are getting approved at a high rate then it’s a good indicator of quality.",
                        },
                        variant: "percentage",
                        value: {
                            property: "stats.approvalRateOnMyMrs",
                        },
                        baseline: {
                            property: "stats.baseline.approvalRateOnMyMrs",
                        },
                    },
                ],
            },
        ],
    },
    healthy_pace_question: {
        id: "healthy_pace_question",
        title: {
            value: "Am I working at a healthy pace?",
        },
        knowledgeBaseName: "questions",
        dependencies: ["git"],
        rows: [
            {
                singleCard: true,
                items: [
                    {
                        query: {
                            id: "git.reviews.reviewStats",
                            assignToProperty: "reviewStats",
                        },
                        title: {
                            value: "Comments authored",
                        },
                        tooltip: {
                            dependencies: "git",
                            text: "How many comments you have made on MRs this week compared to your average. Reveals how engaged you are when reviewing MRs",
                        },
                        variant: "standard",
                        value: {
                            property: "reviewStats.commentsCount",
                        },
                        baseline: {
                            property: "reviewStats.baseline.commentsCount",
                        },
                    },
                    {
                        query: {
                            id: "git.reviews.reviewStats",
                            assignToProperty: "reviewStats",
                        },
                        title: {
                            value: "MRs commented on",
                        },
                        tooltip: {
                            dependencies: "git",
                            text: "How many MRs you have commented on this week compared to your average. Helps show if your colleagues are wrapping too many commits up into single large MRs",
                        },
                        variant: "standard",
                        value: {
                            property: "reviewStats.commentedMrsCount",
                        },
                        baseline: {
                            property: "reviewStats.baseline.commentedMrsCount",
                        },
                    },
                    {
                        query: {
                            id: "git.reviews.reviewStats",
                            assignToProperty: "reviewStats",
                        },
                        title: {
                            value: "Average comments per MR",
                        },
                        tooltip: {
                            dependencies: "git",
                            text: "How many comments you are making per a MR this week versus your average. Details how thorough you are when reviewing MRs",
                        },
                        variant: "standard",
                        value: {
                            property: "reviewStats.averageCommentsPerMr",
                        },
                        baseline: {
                            property: "reviewStats.baseline.averageCommentsPerMr",
                        },
                    },
                    {
                        query: {
                            id: "git.reviews.reviewStats",
                            assignToProperty: "reviewStats",
                        },
                        title: {
                            value: "Approvals given",
                        },
                        tooltip: {
                            dependencies: "git",
                            text: "How many MR approvals you have made this week compared to your average. Shows whether you're approving more MRs over time",
                        },
                        variant: "standard",
                        value: {
                            property: "reviewStats.approvalsCount",
                        },
                        baseline: {
                            property: "reviewStats.baseline.approvalsCount",
                        },
                    },
                    {
                        query: {
                            id: "git.reviews.reviewStats",
                            assignToProperty: "reviewStats",
                        },
                        title: {
                            value: "Avg review pickup time",
                        },
                        tooltip: {
                            dependencies: "git",
                            text: "How fast you picked up reviews (commented or approved) this week versus your average. Demonstrates how fast you're picking up other people's reviews",
                        },
                        variant: "formatted",
                        value: {
                            property: "reviewStats.reviewPickup",
                        },
                        baseline: {
                            property: "reviewStats.baseline.reviewPickup",
                        },
                    },
                    {
                        query: {
                            id: "git.reviews.reviewStats",
                            assignToProperty: "reviewStats",
                        },
                        title: {
                            value: "Total lines reviewed",
                        },
                        tooltip: {
                            dependencies: "git",
                            text: "How many lines of code you have reviewed",
                        },
                        variant: "standard",
                        value: {
                            property: "reviewStats.linesReviewedCount",
                        },
                        baseline: {
                            property: "reviewStats.baseline.linesReviewedCount",
                        },
                    },
                ],
            },
            {
                items: [
                    {
                        id: "git.mrs.timings",
                        query: {
                            id: "git.mrs.timings",
                            assignToProperty: "timings",
                        },
                        title: {
                            value: "Merged MRs duration",
                        },
                        tooltip: {
                            dependencies: "git",
                            text: "Shows how long your MRs are taking to go through each step towards approval. Provides the data to help understand if this process is getting faster/slower at each stage",
                        },
                        skeleton: {
                            streaming: true,
                            property: "timings",
                        },
                        toggle: [
                            {
                                name: "Stats",
                                value: "stats",
                            },
                            {
                                name: "Over Time",
                                value: "timeseries",
                            },
                        ],
                        items: {
                            stats: {
                                specialComponent: "mr-timings",
                            },
                            timeseries: {
                                type: "line-chart",
                                chart: {
                                    type: "line",
                                    property: "timings.timeseries",
                                    expandable: false,
                                    xValues: [
                                        {
                                            dataKey: "week",
                                            type: "datetime",
                                        },
                                    ],
                                    yValues: [
                                        {
                                            type: "monotone",
                                            dataKey: "in_progress_duration_adj_avg",
                                            name: "In progress",
                                            stroke: "#8884d8",
                                            activeDot: {
                                                r: 3,
                                            },
                                            dot: {
                                                r: 0,
                                            },
                                            connectNulls: false,
                                            unit: "duration",
                                        },
                                        {
                                            type: "monotone",
                                            dataKey: "under_review_duration_adj_avg",
                                            name: "Under review",
                                            stroke: "#82ca9d",
                                            activeDot: {
                                                r: 3,
                                            },
                                            dot: {
                                                r: 0,
                                            },
                                            connectNulls: false,
                                            unit: "duration",
                                        },
                                        {
                                            type: "monotone",
                                            dataKey: "approved_to_merge_duration_adj_avg",
                                            name: "Approved to merge",
                                            stroke: "#41adfc",
                                            activeDot: {
                                                r: 3,
                                            },
                                            dot: {
                                                r: 0,
                                            },
                                            connectNulls: false,
                                            unit: "duration",
                                        },
                                        {
                                            type: "monotone",
                                            dataKey: "total_time",
                                            name: "Total time",
                                            stroke: "#f2994a",
                                            activeDot: {
                                                r: 3,
                                            },
                                            dot: {
                                                r: 0,
                                            },
                                            connectNulls: false,
                                            unit: "duration",
                                        },
                                    ],
                                },
                            },
                        },
                        sizing: {
                            xs: 12,
                            md: 6,
                        },
                    },
                ],
            },
        ],
    },

    team_process_question: {
        id: "team_process_question",
        title: {
            value: "Is our review process running well?",
        },
        knowledgeBaseName: "questions-teams",
        dependencies: ["git"],
        rows: [
            {
                singleCard: true,
                items: [
                    {
                        id: "git.reviews.reviewStats.averageCommentsPerMr",
                        query: {
                            id: "git.reviews.reviewStats",
                            assignToProperty: "reviewStats",
                        },
                        title: {
                            value: "Average comments per MR",
                        },
                        tooltip: {
                            dependencies: "git",
                            text: "How many comments you are making per a MR this week versus your average. Details how thorough you are when reviewing MRs",
                        },
                        variant: "standard",
                        value: {
                            property: "reviewStats.averageCommentsPerMr",
                        },
                        baseline: {
                            property: "reviewStats.baseline.averageCommentsPerMr",
                        },
                    },
                    {
                        id: "git.reviews.reviewStats.approvalsCount",
                        query: {
                            id: "git.reviews.reviewStats",
                            assignToProperty: "reviewStats",
                        },
                        title: {
                            value: "Approvals given",
                        },
                        tooltip: {
                            dependencies: "git",
                            text: "How many MR approvals you have made this week compared to your average. Shows whether you're approving more MRs over time",
                        },
                        variant: "standard",
                        value: {
                            property: "reviewStats.approvalsCount",
                        },
                        baseline: {
                            property: "reviewStats.baseline.approvalsCount",
                        },
                    },
                    {
                        id: "git.reviews.reviewStats.reviewPickup",
                        query: {
                            id: "git.reviews.reviewStats",
                            assignToProperty: "reviewStats",
                        },
                        title: {
                            value: "Avg review pickup time",
                        },
                        tooltip: {
                            dependencies: "git",
                            text: "How fast you picked up reviews (commented or approved) this week versus your average. Demonstrates how fast you're picking up other people's reviews",
                        },
                        variant: "formatted",
                        value: {
                            property: "reviewStats.reviewPickup",
                        },
                        baseline: {
                            property: "reviewStats.baseline.reviewPickup",
                        },
                    },
                ],
            },
            {
                singleCard: true,
                items: [
                    {
                        id: "executive.total.tasks",
                        query: {
                            id: "executive.total.tasks",
                            assignToProperty: "tasks",
                        },
                        title: {
                            value: "Reviewing Efficiency",
                        },
                        tooltip: {
                            dependencies: "git",
                            text: "Time it took for PRs from the beginning if their review to their merge.",
                        },
                        variant: "standard",
                        value: {
                            property: "tasks.review_to_merge_time_git",
                        },
                        otherProps: {
                            slope: {
                                propertyPath: "tasks.git_review_time_slope",
                            },
                            type: {
                                value: "time",
                            },
                            customText: {
                                value: "(PRs Merged - no outliers)",
                            },
                        },
                    },
                ],
            },
            {
                items: [
                    {
                        id: "git.mrs.timings",
                        query: {
                            id: "git.mrs.timings",
                            assignToProperty: "timings",
                        },
                        title: {
                            value: "Merged MRs duration",
                        },
                        tooltip: {
                            dependencies: "git",
                            text: "Shows how long your MRs are taking to go through each step towards approval. Provides the data to help understand if this process is getting faster/slower at each stage",
                        },
                        skeleton: {
                            streaming: true,
                            property: "timings",
                        },
                        toggle: [
                            {
                                name: "Stats",
                                value: "stats",
                            },
                            {
                                name: "Over Time",
                                value: "timeseries",
                            },
                        ],
                        items: {
                            stats: {
                                specialComponent: "mr-timings",
                            },
                            timeseries: {
                                type: "line-chart",
                                chart: {
                                    type: "line",
                                    property: "timings.timeseries",
                                    expandable: false,
                                    xValues: [
                                        {
                                            dataKey: "week",
                                            type: "datetime",
                                        },
                                    ],
                                    yValues: [
                                        {
                                            type: "monotone",
                                            dataKey: "in_progress_duration_adj_avg",
                                            name: "In progress",
                                            stroke: "#8884d8",
                                            activeDot: {
                                                r: 3,
                                            },
                                            dot: {
                                                r: 0,
                                            },
                                            connectNulls: false,
                                            unit: "duration",
                                        },
                                        {
                                            type: "monotone",
                                            dataKey: "under_review_duration_adj_avg",
                                            name: "Under review",
                                            stroke: "#82ca9d",
                                            activeDot: {
                                                r: 3,
                                            },
                                            dot: {
                                                r: 0,
                                            },
                                            connectNulls: false,
                                            unit: "duration",
                                        },
                                        {
                                            type: "monotone",
                                            dataKey: "approved_to_merge_duration_adj_avg",
                                            name: "Approved to merge",
                                            stroke: "#41adfc",
                                            activeDot: {
                                                r: 3,
                                            },
                                            dot: {
                                                r: 0,
                                            },
                                            connectNulls: false,
                                            unit: "duration",
                                        },
                                        {
                                            type: "monotone",
                                            dataKey: "total_time",
                                            name: "Total time",
                                            stroke: "#f2994a",
                                            activeDot: {
                                                r: 3,
                                            },
                                            dot: {
                                                r: 0,
                                            },
                                            connectNulls: false,
                                            unit: "duration",
                                        },
                                    ],
                                },
                            },
                        },
                        sizing: {
                            xs: 12,
                            md: 6,
                        },
                    },
                ],
            },
        ],
    },
    team_time_spending_question: {
        id: "team_time_spending_question",
        title: {
            value: "Are we spending our time on the right things?",
        },
        knowledgeBaseName: "questions-teams",
        dependencies: ["git"],
        rows: [
            {
                singleCard: true,
                items: [
                    {
                        id: "collaboration.collaboration.stats.meetings",
                        query: {
                            id: "collaboration.collaboration.stats",
                            assignToProperty: "stats",
                        },
                        title: {
                            value: "Time spent in meetings",
                        },
                        tooltip: {
                            dependencies: "meetings",
                            text: "Shows how much time you are investing in meetings. A good indicator of whether you are managing your day well.",
                        },
                        variant: "formatted",
                        value: {
                            property: "stats.meetingsTime",
                        },
                        baseline: {
                            property: "stats.baseline.meetingsTime",
                        },
                    },
                    {
                        id: "collaboration.collaboration.stats.huddles",
                        query: {
                            id: "collaboration.collaboration.stats",
                            assignToProperty: "stats",
                        },
                        title: {
                            value: "Time spent in huddles",
                        },
                        tooltip: {
                            dependencies: "slack",
                            text: "Shows how much time you spent in Slack huddles in a given week. Helps show if you're collaborating enough.",
                        },
                        variant: "formatted",
                        value: {
                            property: "stats.huddleTime",
                        },
                        baseline: {
                            property: "stats.baseline.huddleTime",
                        },
                    },
                    {
                        id: "executive.total.investment",
                        query: {
                            id: "executive.total.investment",
                            assignToProperty: "investment",
                        },
                        title: {
                            value: "Code Days",
                        },
                        tooltip: {
                            dependencies: "collaboration",
                            text: "Person-working days that were made available for them to work on code (time without breaks, out of office and collaboration).",
                        },
                        variant: "standard",
                        value: {
                            property: "investment.code_duration",
                        },
                        otherProps: {
                            slope: {
                                propertyPath: "investment.code_slope",
                            },
                            type: {
                                value: "time",
                            },
                            customText: {
                                value: "per user-work day",
                            },
                        },
                    },
                    {
                        id: "executive.total.investment",
                        query: {
                            id: "executive.total.investment",
                            assignToProperty: "investment",
                        },
                        title: {
                            value: "Collaborations days",
                        },
                        tooltip: {
                            dependencies: "collaboration",
                            text: "Person-working days invested in collaboration (ie chatting and in meetings).",
                        },
                        variant: "standard",
                        value: {
                            property: "investment.collaboration_duration",
                        },
                        otherProps: {
                            slope: {
                                propertyPath: "investment.colab_slope",
                            },
                            type: {
                                value: "time",
                            },
                            customText: {
                                value: "per user-work day",
                            },
                        },
                    },
                    {
                        id: "executive.total.investment",
                        query: {
                            id: "executive.total.investment",
                            assignToProperty: "investment",
                        },
                        title: {
                            value: "Balance Days",
                        },
                        tooltip: {
                            dependencies: "collaboration",
                            text: "Person-days invested in the team's healthy work-life balance (ie breaks and out of office)",
                        },
                        variant: "standard",
                        value: {
                            property: "investment.break_duration",
                        },
                        otherProps: {
                            slope: {
                                propertyPath: "investment.ooo_slope",
                            },
                            type: {
                                value: "time",
                            },
                            customText: {
                                value: "per user-work day",
                            },
                        },
                    },
                ],
            },
            {
                items: [
                    {
                        id: "collaboration.collaboration.timeCollaboratedPerDay",
                        query: {
                            id: "collaboration.collaboration.timeCollaboratedPerDay",
                            assignToProperty: "timeCollaboratedPerDay",
                        },
                        title: {
                            value: "Time spent communicating",
                        },
                        tooltip: {
                            dependencies: "collaboration",
                            text: "The number of minutes you spent interacting on Slack on a given day vs time spent in meetings. Shows if you're communicating too much/little on a given day",
                        },
                        knowledgeBaseName: "time-spent-communicating",
                        skeleton: {
                            streaming: true,
                            property: "timeCollaboratedPerDay",
                        },
                        type: "line-chart",
                        chart: {
                            type: "line",
                            property: "timeCollaboratedPerDay",
                            expandable: false,
                            xValues: [
                                {
                                    dataKey: "date",
                                    type: "datetime",
                                },
                            ],
                            yValues: [
                                {
                                    type: "linear",
                                    dataKey: "chat",
                                    name: "Time spent on chat",
                                    stroke: "#60d297",
                                    activeDot: {
                                        r: 6,
                                    },
                                    dot: {
                                        r: 0,
                                    },
                                    unit: "duration",
                                },
                                {
                                    type: "linear",
                                    dataKey: "meetings",
                                    name: "Time spent on meetings",
                                    stroke: "#4284F4",
                                    activeDot: {
                                        r: 6,
                                    },
                                    dot: {
                                        r: 0,
                                    },
                                    unit: "duration",
                                },
                            ],
                        },
                        sizing: {
                            xs: 12,
                            md: 4,
                        },
                    },
                    {
                        id: "pm.tickets.workDistribution",
                        query: {
                            id: "pm.tickets.workDistribution",
                            assignToProperty: "workDistribution",
                            variables: {
                                "creator-assignee": "$.queryVariablesSetter.creator-assignee.value",
                            },
                        },
                        title: {
                            value: "Active tickets distribution",
                        },
                        tooltip: {
                            dependencies: "pm",
                            text: "Get a better idea of how your work is divided. By gaining a deeper understanding of how your work is divided and allocated, you can improve your ability to effectively manage and prioritize tasks",
                        },
                        skeleton: {
                            streaming: true,
                            property: "workDistribution",
                        },
                        type: "pie-chart",
                        chart: {
                            type: "pie",
                            property: "workDistribution",
                            nameKey: "name",
                            dataKey: "issues",
                            sortKey: "issues",
                            tooltipKeys: [
                                {
                                    property: "issues",
                                    name: "Active issues",
                                },
                                {
                                    property: "value.timeSpent",
                                    name: "Time spent",
                                    type: "duration",
                                },
                                {
                                    property: "value.ticketsTimeSpent",
                                    name: "Tickets with time input",
                                },
                            ],
                        },
                        sizing: {
                            md: 4,
                            xs: 12,
                        },
                    },
                    {
                        id: "collaboration.collaboration.meetingFrequency",
                        query: {
                            id: "collaboration.collaboration.meetingFrequency",
                            assignToProperty: "meetingFrequency",
                        },
                        title: {
                            value: "Hours in meetings",
                        },
                        tooltip: {
                            dependencies: "meetings",
                            text: "Uncover which meetings are blocking the most time in your calendar",
                        },
                        knowledgeBaseName: "hours-in-meetings",
                        skeleton: {
                            streaming: true,
                            property: "meetingFrequency",
                        },
                        type: "pie-chart",
                        chart: {
                            type: "pie",
                            property: "meetingFrequency",
                            nameKey: "name",
                            dataKey: "duration",
                            sortKey: "duration",
                            tooltipKeys: [
                                {
                                    property: "duration",
                                    name: "Time in meeting",
                                    type: "duration",
                                },
                                {
                                    property: "baseline",
                                    name: "Average time in meeting",
                                    type: "duration",
                                },
                            ],
                        },
                        sizing: {
                            xs: 12,
                            md: 4,
                        },
                    },
                ],
            },
            {
                items: [
                    {
                        id: "pm.tickets.ticketsOverview",
                        query: {
                            id: "pm.tickets.ticketsOverview",
                            assignToProperty: "ticketsOverview",
                            variables: {
                                "creator-assignee": "$.queryVariablesSetter.creator-assignee.value",
                            },
                        },
                        title: {
                            value: "Tickets overview",
                        },
                        tooltip: {
                            dependencies: "pm",
                            text: "Your Personal cumulative flow diagram",
                        },
                        skeleton: {
                            streaming: true,
                            property: "ticketsOverview",
                        },
                        toggle: [
                            {
                                name: "",
                                value: "new",
                            },
                            {
                                name: "Include old Done tickets",
                                value: "all",
                            },
                        ],
                        items: {
                            all: {
                                type: "area-chart",
                                chart: {
                                    type: "area",
                                    property: "ticketsOverview",
                                    yValues: [
                                        {
                                            type: "monotone",
                                            dataKey: "doneAll.issues",
                                            name: "Done",
                                            stackId: "1",
                                            stroke: "#ffc658",
                                            fill: "#ffc658",
                                        },
                                        {
                                            type: "monotone",
                                            dataKey: "todoAll.issues",
                                            name: "To Do",
                                            stackId: "1",
                                            stroke: "#8884d8",
                                            fill: "#8884d8",
                                        },
                                        {
                                            type: "monotone",
                                            dataKey: "inProgressAll.issues",
                                            name: "In Progress",
                                            stackId: "1",
                                            stroke: "#82ca9d",
                                            fill: "#82ca9d",
                                        },
                                    ],
                                    xValues: [
                                        {
                                            dataKey: "datetime",
                                            type: "datetime",
                                        },
                                    ],
                                },
                            },
                            new: {
                                type: "area-chart",
                                chart: {
                                    type: "area",
                                    property: "ticketsOverview",
                                    yValues: [
                                        {
                                            type: "monotone",
                                            dataKey: "done.issues",
                                            name: "Done",
                                            stackId: "1",
                                            stroke: "#ffc658",
                                            fill: "#ffc658",
                                        },
                                        {
                                            type: "monotone",
                                            dataKey: "todo.issues",
                                            name: "To Do",
                                            stackId: "1",
                                            stroke: "#8884d8",
                                            fill: "#8884d8",
                                        },
                                        {
                                            type: "monotone",
                                            dataKey: "inProgress.issues",
                                            name: "In Progress",
                                            stackId: "1",
                                            stroke: "#82ca9d",
                                            fill: "#82ca9d",
                                        },
                                    ],
                                    xValues: [
                                        {
                                            dataKey: "datetime",
                                            type: "datetime",
                                        },
                                    ],
                                },
                            },
                        },
                        sizing: {
                            xs: 12,
                            md: 6,
                        },
                    },
                    {
                        id: "pm.tickets.bugs",
                        query: {
                            id: "pm.tickets.bugs",
                            assignToProperty: "bugs",
                            variables: {
                                "creator-assignee": "$.queryVariablesSetter.creator-assignee.value",
                            },
                        },
                        title: {
                            value: "Bug tickets",
                        },
                        tooltip: {
                            dependencies: "pm",
                            text: " ",
                        },
                        skeleton: {
                            streaming: true,
                            property: "bugs",
                        },
                        filter: {
                            id: "env",
                            type: "dropdown",
                            dynamicOptions: "$data.bugs[*].environment",
                        },
                        type: "line-chart",
                        chart: {
                            type: "line",
                            property: "bugs",
                            filterBy: "environment",
                            expandable: false,
                            xValues: [
                                {
                                    dataKey: "datetime",
                                    type: "datetime",
                                },
                            ],
                            yValues: [
                                {
                                    type: "monotone",
                                    dataKey: "created_count",
                                    name: "Created",
                                    stroke: "#B8F7D1",
                                    activeDot: {
                                        r: 3,
                                    },
                                    dot: {
                                        r: 0,
                                    },
                                    unit: "number",
                                },
                                {
                                    type: "monotone",
                                    dataKey: "done_count",
                                    name: "Done",
                                    stroke: "#ffc658",
                                    activeDot: {
                                        r: 3,
                                    },
                                    dot: {
                                        r: 0,
                                    },
                                    unit: "number",
                                },
                                {
                                    type: "monotone",
                                    dataKey: "in_backlog_count",
                                    name: "Backlog",
                                    stroke: "#8884d8",
                                    activeDot: {
                                        r: 3,
                                    },
                                    dot: {
                                        r: 0,
                                    },
                                    unit: "number",
                                },
                                {
                                    type: "monotone",
                                    dataKey: "in_progress_count",
                                    name: "In Progress",
                                    stroke: "#82ca9d",
                                    activeDot: {
                                        r: 3,
                                    },
                                    dot: {
                                        r: 0,
                                    },
                                    unit: "number",
                                },
                            ],
                        },
                        sizing: {
                            xs: 12,
                            md: 6,
                        },
                    },
                ],
            },
        ],
    },
    team_sustainability_question: {
        id: "team_sustainability_question",
        title: {
            value: "Are our engineers working sustainably?",
        },
        knowledgeBaseName: "questions-teams",
        dependencies: ["git"],
        rows: [
            {
                singleCard: true,
                items: [
                    {
                        id: "executive.total.investment",
                        query: {
                            id: "executive.total.investment",
                            assignToProperty: "investment",
                        },
                        title: {
                            value: "Long Working Hours",
                        },
                        tooltip: {
                            dependencies: "git",
                            text: "",
                        },
                        variant: "standard",
                        value: {
                            property: "investment.long_hours",
                        },
                        otherProps: {
                            slope: {
                                propertyPath: "investment.long_hours_slope",
                            },
                            type: {
                                value: "time",
                            },
                            customText: {
                                value: "per user-work day",
                            },
                        },
                    },
                    {
                        id: "executive.total.investment",
                        query: {
                            id: "executive.total.investment",
                            assignToProperty: "investment",
                        },
                        title: {
                            value: "Out of hours working",
                        },
                        tooltip: {
                            dependencies: "git",
                            text: "Person-working days spent working outside of your normal working hours (as defined in their profile).",
                        },
                        variant: "standard",
                        value: {
                            property: "investment.out_of_working_hours",
                        },
                        otherProps: {
                            slope: {
                                propertyPath: "investment.out_of_working_hours_slope",
                            },
                            type: {
                                value: "time",
                            },
                            customText: {
                                value: "per user-work day",
                            },
                        },
                    },
                    {
                        id: "executive.total.investment",
                        query: {
                            id: "executive.total.investment",
                            assignToProperty: "investment",
                        },
                        title: {
                            value: "Available Focus Time",
                        },
                        tooltip: {
                            dependencies: "collaboration",
                            text: "Person-working days available for deep focus time (different from code days, as it assumes you can not get into deep focus without at least 1 continuous hour uninterrupted).",
                        },
                        variant: "standard",
                        value: {
                            property: "investment.focus_duration",
                        },
                        otherProps: {
                            slope: {
                                propertyPath: "investment.focus_slope",
                            },
                            type: {
                                value: "time",
                            },
                            customText: {
                                value: "per user-work day",
                            },
                        },
                    },
                ],
            },
            {
                id: "pm.tickets.ticketsAssigned",
                query: {
                    id: "pm.tickets.ticketsAssigned",
                    assignToProperty: "ticketsAssigned",
                    variables: {
                        "creator-assignee": "$.queryVariablesSetter.creator-assignee.value",
                    },
                },
                title: {
                    value: "Tickets assigned",
                },
                tooltip: {
                    dependencies: "pm",
                    text: "Keeping track of the number of issues that are assigned to you each day of the week can provide valuable insights into the workload distribution of your project and help you identify potential areas for improvement",
                },
                skeleton: {
                    streaming: true,
                    property: "ticketsAssigned",
                },
                type: "line-chart",
                chart: {
                    type: "line",
                    property: "ticketsAssigned",
                    expandable: false,
                    xValues: [
                        {
                            dataKey: "day",
                            type: "weekday",
                        },
                    ],
                    yValues: [
                        {
                            type: "monotone",
                            dataKey: "max.issues",
                            name: "Most issues",
                            stroke: "#82ca9d",
                            style: {
                                opacity: "0",
                            },
                            unit: "number",
                        },
                        {
                            type: "monotone",
                            dataKey: "min.issues",
                            name: "Least issues",
                            stroke: "#8884d8",
                            style: {
                                opacity: "0",
                            },
                            unit: "number",
                        },
                    ],
                    customized: ["rectangle"],
                },
                sizing: {
                    xs: 12,
                    md: 3,
                },
            },
            {
                items: [
                    {
                        id: "wellbeing.wellbeing.longHours",
                        query: {
                            id: "wellbeing.wellbeing.longOutHours",
                            extractFromProperty: "longHours",
                            assignToProperty: "longHours",
                        },
                        title: {
                            value: "Long Hours",
                        },
                        tooltip: {
                            dependencies: "wellbeing",
                            text: "Working Hours Surpassed. Working long hours consistently has a negative impact on wellbeing",
                        },
                        knowledgeBaseName: "long-hours",
                        skeleton: {
                            streaming: true,
                            property: "longHours",
                        },
                        type: "bar-chart",
                        chart: {
                            type: "bar",
                            property: "longHours",
                            yValues: [
                                {
                                    dataKey: "value",
                                    name: "Long hours",
                                    fill: "#8884d8",
                                    type: "duration",
                                },
                                {
                                    dataKey: "baseline",
                                    name: "Average ",
                                    fill: "#82ca9d",
                                    maxBarSize: 10,
                                    barSize: 1,
                                    type: "duration",
                                },
                            ],
                            xValues: [
                                {
                                    dataKey: "datetime",
                                    type: "datetime",
                                },
                            ],
                        },
                        sizing: {
                            xs: 12,
                            md: 4,
                        },
                    },
                    {
                        id: "wellbeing.wellbeing.focusTime",
                        query: {
                            id: "wellbeing.wellbeing.focusTime",
                            assignToProperty: "focusTime",
                        },
                        title: {
                            value: "Focus time",
                        },
                        tooltip: {
                            dependencies: "collaboration",
                            text: "Time available for deep solo work. How many hours are available to you for productive and deep focus work",
                        },
                        knowledgeBaseName: "focus-time",
                        skeleton: {
                            streaming: true,
                            property: "focusTime",
                        },
                        type: "heatmap-chart",
                        chart: {
                            type: "heatmap",
                            property: "focusTime",
                            options: {
                                inverse: true,
                                type: "time",
                            },
                            yValues: [
                                {
                                    dataKey: "reactions",
                                    name: "Reactions",
                                    type: "duration",
                                    multiplier: 1,
                                    aggregationMethod: "avg",
                                },
                                {
                                    dataKey: "messages",
                                    name: "Messages",
                                    type: "duration",
                                    multiplier: 1,
                                    aggregationMethod: "avg",
                                },
                                {
                                    dataKey: "huddles",
                                    name: "Huddles",
                                    type: "duration",
                                    multiplier: 1,
                                    aggregationMethod: "avg",
                                },
                                {
                                    dataKey: "meetings",
                                    name: "Meetings",
                                    type: "duration",
                                    multiplier: 1,
                                    aggregationMethod: "avg",
                                },
                                {
                                    dataKey: "focus",
                                    name: "Focus",
                                    type: "number",
                                    multiplier: 1,
                                    aggregationMethod: "avg",
                                    border: {
                                        color: "#60D297",
                                        width: "1px",
                                        style: "dashed",
                                        radius: "4px",
                                        height: "23px",
                                    },
                                },
                            ],
                            xValues: [
                                {
                                    dataKey: "datetime",
                                    type: "datetime",
                                },
                            ],
                            cellStyle: {
                                background: {
                                    r: 136,
                                    g: 132,
                                    b: 216,
                                },
                                opacity: 1,
                                fontSize: "0",
                                border: {
                                    color: "#474747",
                                    width: "1px",
                                    style: "solid",
                                    radius: "4px",
                                    height: "23px",
                                },
                            },
                        },
                        sizing: {
                            xs: 12,
                            md: 8,
                        },
                    },
                ],
            },
            {
                items: [
                    {
                        id: "collaboration.collaboration.messageCountPerDay",
                        query: {
                            id: "collaboration.collaboration.messageCountPerDay",
                            assignToProperty: "messageCountPerDay",
                        },
                        title: {
                            value: "Public, private channels vs direct",
                        },
                        tooltip: {
                            dependencies: "slack",
                            text: "Shows which types of channels you spent your time communicating in by day alongside averages. Gives insight around whether your engaging enough in channels, or making use of direct communication enough",
                        },
                        knowledgeBaseName: "public-private",
                        skeleton: {
                            streaming: true,
                            property: "messageCountPerDay",
                        },
                        type: "bar-chart",
                        chart: {
                            type: "bar",
                            property: "messageCountPerDay",
                            yValues: [
                                {
                                    dataKey: "public",
                                    name: "Public Channels",
                                    stackId: "a",
                                    fill: "#6C63F0",
                                    type: "number",
                                },
                                {
                                    propertyPath: "baseline.public",
                                    dataKey: "averagePublic",
                                    name: "Public average on ",
                                    stackId: "b",
                                    fill: "#9993F6",
                                    maxBarSize: 10,
                                    type: "dow",
                                },
                                {
                                    dataKey: "private",
                                    name: "Private Channels",
                                    stackId: "a",
                                    fill: "#3AACFF",
                                    type: "number",
                                },
                                {
                                    propertyPath: "baseline.private",
                                    dataKey: "averagePrivate",
                                    name: "Private average on ",
                                    stackId: "b",
                                    fill: "#8ECEFC",
                                    maxBarSize: 10,
                                    type: "dow",
                                },
                                {
                                    dataKey: "im",
                                    name: "IM",
                                    stackId: "a",
                                    fill: "#ED589D",
                                    type: "number",
                                },
                                {
                                    propertyPath: "baseline.im",
                                    dataKey: "averageIm",
                                    name: "IM average on ",
                                    stackId: "b",
                                    fill: "#F4A7CB",
                                    maxBarSize: 10,
                                    type: "dow",
                                },
                            ],
                            xValues: [
                                {
                                    dataKey: "datetime",
                                    type: "datetime",
                                },
                            ],
                            tooltipValues: [
                                {
                                    dataKey: "all",
                                    name: "Total messages",
                                    type: "number",
                                },
                                {
                                    propertyPath: "baseline.all",
                                    dataKey: "averageAll",
                                    name: "Total average on ",
                                    type: "dow",
                                },
                            ],
                        },
                        sizing: {
                            xs: 12,
                            md: 4,
                        },
                    },
                ],
            },
        ],
    },
    team_code_quality_question: {
        id: "team_code_quality_question",
        title: {
            value: "Does our planning, process, and pipeline infrastructure allow us to produce high quality code?",
        },
        knowledgeBaseName: "questions-teams",
        dependencies: ["git"],
        rows: [
            {
                singleCard: true,
                items: [
                    {
                        id: "executive.total.scope-creep",
                        query: {
                            id: "executive.total.scope-creep",
                            assignToProperty: "scope-creep",
                        },
                        title: {
                            value: "Sprint Planning Accuracy",
                        },
                        tooltip: {
                            dependencies: "git",
                            text: "Volume (number of issues) of scope creep in the Jira sprints that this group of people contributed to (only tickets that we created by or assigned to this group are measured)",
                        },
                        variant: "standard",
                        value: {
                            property: "scope-creep.totals.total",
                        },
                        otherProps: {
                            slope: {
                                propertyPath: "stats.git_review_time_slope",
                            },
                            type: {
                                value: "time",
                            },
                            customText: {
                                value: "per user-work day",
                            },
                        },
                    },
                    {
                        id: "executive.total.backlog",
                        query: {
                            id: "executive.total.backlog",
                            assignToProperty: "backlog",
                        },
                        title: {
                            value: "Backlog Size",
                        },
                        tooltip: {
                            dependencies: "git",
                            text: "Amount of current backlog tickets, and the new issues added in the backlog during the period.",
                        },
                        variant: "standard",
                        value: {
                            property: "backlog.issues",
                        },
                        otherProps: {
                            slope: {
                                propertyPath: "backlog.issues_slope",
                            },
                            type: {
                                value: "custom",
                            },
                            customText: {
                                value: "total issues",
                            },
                        },
                    },
                    {
                        id: "executive.total.bugs-detected",
                        query: {
                            id: "executive.total.bugs-detected",
                            assignToProperty: "bugs-detected",
                        },
                        title: {
                            value: "Bugs Detected",
                        },
                        tooltip: {
                            dependencies: "git",
                            text: "Amount of bug tickets assigned or created by this group of people during the period.",
                        },
                        variant: "standard",
                        value: {
                            property: "bugs-detected.total_issues",
                        },
                        otherProps: {
                            slope: {
                                propertyPath: "bugs-detected.slope",
                            },
                            type: {
                                value: "custom",
                            },
                            customText: {
                                value: "new bug issues",
                            },
                        },
                    },
                    {
                        id: "executive.total.rework",
                        query: {
                            id: "executive.total.rework",
                            assignToProperty: "rework",
                        },
                        title: {
                            value: "Reworked Code Ratio",
                        },
                        tooltip: {
                            dependencies: "git",
                            text: "Ratio of existing code changed over the total amount of changes done in the code. Indication of how much old code is getting changed vs new code added without changing the old. Should be kept in a healthy ratio around the middle zone, depending on the work done by the team (new project or BAU).",
                        },
                        variant: "standard",
                        value: {
                            property: "rework.rework_total_ratio",
                        },
                        otherProps: {
                            slope: {
                                propertyPath: "rework.slope",
                            },
                            type: {
                                value: "percentile",
                            },
                            customText: {
                                value: "of lines changed that were pre-existing",
                            },
                        },
                    },
                    {
                        id: "executive.total.maintainability",
                        query: {
                            id: "executive.total.maintainability",
                            assignToProperty: "maintainability",
                        },
                        title: {
                            value: "Maintainability Index",
                        },
                        tooltip: {
                            dependencies: "git",
                            text: "The sum of the changes on the code maintainability index of all repos altered by this group of people in this period.",
                        },
                        variant: "standard",
                        value: {
                            property: "maintainability.maintainability_influence",
                        },
                        otherProps: {
                            slope: {
                                propertyPath: "stats.git_review_time_slope",
                            },
                            type: {
                                value: "custom",
                            },
                            customText: {
                                value: "Total index change",
                            },
                        },
                    },
                ],
            },
            {
                items: [
                    {
                        id: "collaboration.collaboration.commsPerDayHour",
                        query: {
                            id: "collaboration.collaboration.commsPerDayHour",
                            assignToProperty: "commsPerDayHour",
                        },
                        title: {
                            value: "Time of communication",
                        },
                        tooltip: {
                            dependencies: "collaboration",
                            text: "What time and day you are communicating. The more green the square, the more you communicate in that slot. Increases understanding of when you have time for deep work",
                        },
                        knowledgeBaseName: "time-of-communications",
                        skeleton: {
                            streaming: true,
                            property: "commsPerDayHour",
                        },
                        type: "heatmap-chart",
                        chart: {
                            type: "heatmap",
                            property: "commsPerDayHour",
                            options: {
                                inverse: false,
                                type: "time",
                            },
                            yValues: [
                                {
                                    dataKey: "reactions",
                                    name: "Reactions",
                                    type: "number",
                                    multiplier: 1,
                                    aggregationMethod: "sum",
                                },
                                {
                                    dataKey: "messages",
                                    name: "Messages",
                                    type: "number",
                                    multiplier: 1,
                                    aggregationMethod: "sum",
                                },
                                {
                                    dataKey: "huddles",
                                    name: "Huddles",
                                    type: "number",
                                    multiplier: 1,
                                    aggregationMethod: "sum",
                                },
                                {
                                    dataKey: "meetings",
                                    name: "Meetings",
                                    type: "number",
                                    multiplier: 1,
                                    aggregationMethod: "sum",
                                },
                            ],
                            xValues: [
                                {
                                    dataKey: "datetime",
                                    type: "datetime",
                                },
                            ],
                            cellStyle: {
                                background: {
                                    r: 12,
                                    g: 160,
                                    b: 44,
                                },
                                fontSize: "0",
                                border: {
                                    color: "#3d3d3d",
                                    width: "1px",
                                    style: "solid",
                                    radius: "4px",
                                    height: "23px",
                                },
                            },
                        },
                        sizing: {
                            md: 12,
                            xs: 12,
                        },
                    },
                ],
            },
        ],
    },
};

export default questionsMockTemplates;
